import { BaseDto } from "../base/baseDto.model";

export class TipoDocumentoDto extends BaseDto {

}
